/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["tr",[["Ã¶Ã¶","Ã¶s"],["ÃÃ","ÃS"]],[["ÃÃ","ÃS"]],[["P","P","S","Ã","P","C","C"],["Paz","Pzt","Sal","Ãar","Per","Cum","Cmt"],["Pazar","Pazartesi","SalÄ±","ÃarÅamba","PerÅembe","Cuma","Cumartesi"],["Pa","Pt","Sa","Ãa","Pe","Cu","Ct"]],u,[["O","Å","M","N","M","H","T","A","E","E","K","A"],["Oca","Åub","Mar","Nis","May","Haz","Tem","AÄu","Eyl","Eki","Kas","Ara"],["Ocak","Åubat","Mart","Nisan","MayÄ±s","Haziran","Temmuz","AÄustos","EylÃ¼l","Ekim","KasÄ±m","AralÄ±k"]],u,[["MÃ","MS"],u,["Milattan Ãnce","Milattan Sonra"]],1,[6,0],["d.MM.y","d MMM y","d MMMM y","d MMMM y EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[",",".",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","%#,##0","Â¤#,##0.00","#E0"],"TRY","âº","TÃ¼rk lirasÄ±",{"AUD":["AU$","$"],"BYN":[u,"Ñ."],"PHP":[u,"â±"],"RON":[u,"L"],"RUR":[u,"Ñ."],"THB":["à¸¿"],"TRY":["âº"],"TWD":["NT$"]},"ltr", plural];
